import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { CobService } from 'src/app/services/api/cob.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {InstallationSpecificationService} from 'src/app/services/util/installation-specification.service';
import { MatDialog } from '@angular/material/dialog';
import { CobDetailsComponent } from 'src/app/components/instance-details/cob-details/cob-details.component';
import { translate } from '@jsverse/transloco';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { DynamicFormComponent } from 'src/app/components/dynamic-form-cob/dynamic-form.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import cronstrue from 'cronstrue';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { MatTableDataSource } from '@angular/material/table';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { DeploymentClass } from 'src/app/models/instance-class';
import { InstanceEnvironment } from 'src/app/models/instance-environment';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { Instance } from 'src/app/models/instance/instance';
import { AvailabilityStatus } from 'src/app/models/availability-status';

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.SANITY_TEST_NONPII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.SANITY_TEST_PII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.SANITY_TEST_LIVE,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.EF_TEST_NONPII,
    name: Feature.EF_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.COB_NONPII,
    name: Feature.COB,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.COB_PII,
    name: Feature.COB,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.COB_LIVE,
    name: Feature.COB,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_NONPII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_PII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_LIVE,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.DATABASE_ARCHIVE_LIVE,
    name: Feature.DATABASE_ARCHIVE,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.RVT_TEST_NONPII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.RVT_TEST_PII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  }
];

@Component({
  selector: 'app-environment-cob',
  templateUrl: './environment-cob.component.html',
  styleUrl: './environment-cob.component.scss',
   providers: [
        DurationPipe,
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
  standalone: false
})

export class EnvironmentCobComponent {

  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @Input() data: any;
  isAWS: boolean;
  instance: Instance;
  DeployStatus = DeployStatus;
  sch1: string;
  sch2: string;
  isCobLoaded: boolean;
  showLoader = false;
  showSpinner = false;

  DeploymentClass = DeploymentClass;
  instanceEnvironment = InstanceEnvironment;
  featuresMap: { [key: string]: boolean };
  FeatureKeys = FeatureKeys;


  private destroyRef = inject(DestroyRef);
  instanceId: any;
  routeData: any;
  installationSpecificationForms: any;
  cobResults: any;
  pageIndex = 0;
  cobPaginationSize = 10;
  dataSourceCob: any;
  dataSourceInnerCob: any;
  expandedElement: any;
  clientName: any;
  cobTable: any;
  adoPipelineUrl: any;
  adoProjectName: any;
  AvailabilityStatus = AvailabilityStatus;

  cobColumns: string[] = ['menu','id', 'date', 'timeTaken', 'completionMode', 'status', 'download', 'cobMenu'];
  innerCobColumns: string[] = ['stage', 'startTime', 'endTime', 'duration', 'status', 'message'];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.INITIALIZING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INPROGRESS];

    readonly COB_ENABLE_STATES = [
    DeployStatus.DEPLOYED,
    DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED,
    DeployStatus.CONFIGURED,
    DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.TESTED,
    DeployStatus.TEST_FAILED,
  ];
  
  constructor(private cobService: CobService, private route: ActivatedRoute, private installationSpecificationService: InstallationSpecificationService, private dialog: MatDialog, private toastrService: CustomToastrService, private sidenavService: SidenavService, private instanceService: InstancesService, private durationPipe: DurationPipe, private tenantService: TenantService,
    private featurePermissionsService: FeaturePermissionsService, private crvtService: CRVTService, private router: Router) {
  }

  ngOnInit(): void {    
      this.tenantService.tenantData$.subscribe((data: any) => {
        this.isAWS = data === CloudProvider.AWS ? true : false;
      });
      if (this.COB_ENABLE_STATES.includes(this.data?.status)) {
    this.isCobLoaded = true;
  }
      this.instanceId = this.route.snapshot.params.instanceId;
      this.clientName = this.router.url.split('.')[0].split('/')[3];
      this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
      this.updateEnvironment(this.data);
      this.cobResultsTable();
      this.getTenantDetails();
   }

getTenantDetails() {
  this.tenantService.getTenantDetails(this.data.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
      this.adoPipelineUrl = data?.adoPipelineUrl;
      this.adoProjectName = data?.adoProjectName;
    });
}

   updateEnvironment(data) {
  switch (data.deploymentClass) {
    case DeploymentClass.D:
      this.data.environment = InstanceEnvironment.DEV;
      break;
    case DeploymentClass.C:
      this.data.environment = InstanceEnvironment.TEST;
      break;
    case DeploymentClass.B:
      this.data.environment = InstanceEnvironment.PREPROD;
      break;
    case DeploymentClass.A:
      this.data.environment = InstanceEnvironment.LIVE;
      break;
  }
}

   openCobPipelineUrl(url: string) {
    window.open(url, '_blank');
  }

 viewCobDetails(): void {
    this.showLoader = true;
    let cobInstallSpec: any;
    this.cobService.getCobConfigSpec(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((cobSpec: any) => {
      this.showLoader = false;
      cobInstallSpec = this.installationSpecificationService
      .buildDynamicForms(atob(cobSpec?.spec));
      cobInstallSpec.forEach(installationSpecificationForm => {
        this.mapProperties(installationSpecificationForm, this.data?.cob?.inputs);
      });

      const installDocRaw = Object.keys(this.data?.cob?.inputs);
      cobInstallSpec = cobInstallSpec.filter(item => installDocRaw.includes(item.property.name));
      this.dialog.open(CobDetailsComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        data: {
          dynamicForm: cobInstallSpec,
          instance: this.data
        }
      });
    }, (error) => {
      this.showLoader = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  mapProperties(installationSpecificationForm, selectedVersion): void {
    const keys = Object.keys(selectedVersion);
    keys.forEach(key => {
      if (key === installationSpecificationForm?.property?.name) {
        const properties = installationSpecificationForm.property?.properties;
        if (installationSpecificationForm.property?.type === InstallationSchemaPropertyType.ARRAY) {
          installationSpecificationForm.property.items.enum = selectedVersion[key];
        }
        if(properties) {
          properties.forEach(property =>{
            const selectedItem = Object.keys(selectedVersion[key]);
            selectedItem.forEach(item => {
              if (property?.name === item) {
                property.value = selectedVersion[key][item];
              }
            });
          });
        }
      }
    });
  }

  deleteCobDetails(data): any {
    if(this.data?.cob?.status !==  DeployStatus.DELETING) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.COB_DELETE'),
          message: translate('INSTANCE_DETAILS.COB_MESSAGE'),
          confirmButtonText: translate('BUTTONS.DELETE')
        }
      })
        .afterClosed()
        .subscribe({
          next: (confirm) => {
            if (confirm) {
              const cobConfig = {
                id: this.instanceId,
                'operation': 'DELETE'
              }
              this.cobService.putCobConfig(cobConfig)
                .pipe(
                  takeUntilDestroyed(this.destroyRef))
                .subscribe((res) => {
                  if (res) {
                    this.routeData = res;
                  }
                },
                (error) => {
                  const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                  this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.DELETE_COB_FAILED'),
                      description: errorMessage}
                    });
                });
            }
          },
          error: (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.DELETE_COB_NOT_AVAILABLE'),
                description: errorMessage
              }
            });
          },
          complete: () => {
            // handle completion if needed
          }
        });
      }
  }

  menuItemClick(): void {
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  sortCobData(event) : void {
    this.cobTable = this.sortCobInstanceData(event);
    this.pageIndex = 0;
    const data = this.cobTable?.slice(0, 0 + this.cobPaginationSize);
    this.dataSourceCob = new MatTableDataSource(data);
  }

  sortCobInstanceData(event): void {
    return this.cobTable?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'date':
          comparatorResult = new Date(a?.cobDate)?.getTime() < new Date(b?.cobDate)?.getTime() ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  cobPageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.cobPaginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.cobPaginationSize;
      const data = this.cobTable?.slice(firstIndex, firstIndex + this.cobPaginationSize);
      this.dataSourceCob = new MatTableDataSource(data);
    }
  }

  messageClick(data): void {
    this.dialog.open(ErrorDialogComponent, {
    minHeight: '200px',
    width: '480px',
    panelClass: 'flex-dialog',
    autoFocus: false,
      data: {
        internalError: true,
        title: translate('INSTANCE_DETAILS.COB_INITIALIZATION'),
        description: data.stage,
        note: data.message
      }
    });
  }

  menuClick(cobData): void {
    const data = {
      id: this.instanceId,
      cobId: cobData.cobRunId,
      completionMode: "manual"
    }
    this.cobService.putCobConfigbyId(data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
      if(result) {
        this.cobResultsTable();
      }
    },(error)=>{
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.UPDATE_COB_FAILED'),
          description: errorMessage}
        });
    });
  }
  private getPreviousVersionData(installDocRaw): void {
    this.cobService.getCobConfigSpec(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((cobSpec: any) => {
        this.installationSpecificationForms = this.installationSpecificationService.buildDynamicForms(atob(cobSpec?.spec));
      });
    Object.keys(installDocRaw).forEach(key => {
      const propertyKey = Object.keys(installDocRaw[key]);
      const propertyValue = Object.assign(installDocRaw[key]);
      propertyKey.forEach(controlName => {
        this.installationSpecificationForms?.forEach(nestedForm => {
          nestedForm?.formGroup?.controls[key]?.get(controlName)?.setValue(
            propertyValue[controlName].length === undefined ? '' : propertyValue[controlName]);
          nestedForm?.property?.properties?.forEach(element => {
            if (nestedForm?.formGroup?.controls[key]?.get(element.name)) {
              element.updatedValue = nestedForm.formGroup.controls[key].get(element.name).value;
            }
          });
        });
      });
    });
  }

  cobResultsTable(): void {
    this.showLoader = true;
    this.instanceService.getInstanceById(this.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instance: any) => {
        if(instance) {
          this.data = instance;
          if(this.data?.cob && this.data?.cob?.inputs) {
            const propertyKey = Object.keys(this.data?.cob?.inputs);
            const title = propertyKey[0];
            if(this.data?.cob?.inputs[title]) {
              this.sch1 = cronstrue.toString(this.data?.cob?.inputs[title]?.Schedule1);
              this.sch2 = cronstrue.toString(this.data?.cob?.inputs[title]?.Schedule2);
            }
          }
        }
      });
      this.cobService.getCobConfigSpec(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((cobSpec: any) => {
        this.installationSpecificationForms = this.installationSpecificationService.buildDynamicForms(atob(cobSpec?.spec));
      });
    this.cobService.getCobConfigResults(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((cobResults: any) => {
      if (Number(cobResults?.total) > 10) {
        const size = cobResults?.total;
        this.cobService.getCobConfigResults(this.instanceId, size)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((cobResults: any) => {
          this.cobResults = cobResults.data;
          this.cobResultsExtended();
          this.showLoader = false;
        });
      } else {
        this.cobResults = cobResults.data;
        this.cobResultsExtended();
        this.showLoader = false;
      }
    },(error) => {
        this.showLoader = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }

  cobResultsExtended(): void {
      this.cobResults.forEach(item => {
        item.cobDate = item.cobDate.substr(0, 4) + "-" + item.cobDate.substr(4, 2) + "-" + item.cobDate.substr(6, 2);
        }
      )
      if(this.cobResults?.length > 0) {
        this.cobResults?.forEach(element => {
          element.updatedStages = [];
          let obj;
          element.stages =element?.stages.filter(item => item.stage !== 'COB-REPORT');
          element?.stages.forEach(innerElement => {
            if(element?.updatedStages?.find(item => (item.stage === innerElement.stage) && (innerElement.status.toLowerCase() !== 'started'))) {
              element.updatedStages.find(item => (item.stage === innerElement.stage)).endTime = innerElement.time.trim();
              element.updatedStages.find(item => (item.stage === innerElement.stage)).status = innerElement.status.toLowerCase();
              element.updatedStages.find(item => (item.stage === innerElement.stage)).message = innerElement.message;
            } else {
            obj = innerElement;
            obj.startTime = innerElement.time.trim();
            obj.status = innerElement.status.toLowerCase();
            element.updatedStages = [...element.updatedStages, obj];
            }
          })
          element.updatedStages.forEach(item => {
            item.duration = this.durationPipe.transform(item.startTime, item.endTime, undefined);
            item.milliseconds = new Date(item.endTime).getTime()
            - new Date(item.startTime).getTime();
          })
          element.totalMilliSeconds = [];
          element.updatedStages.forEach(item => {
            if(item.milliseconds) {
              element.totalMilliSeconds = Number(element.totalMilliSeconds) + Number(item.milliseconds);
            }
          });
          element.updatedStages.forEach(item => {
            element.totalTime = this.convertMiliseconds(element.totalMilliSeconds);
          });
          if(element.completionMode === 'manual') {
            element.status = 'failed'
          } else {
            element.updatedStages.find(item => (item.status.toLowerCase() === 'failed')) ? element.status = 'failed' : (element.updatedStages.find(item => (item.status.toLowerCase() === 'started'))) ? element.status = 'started' : ((element.updatedStages.find(item => (item.status.toLowerCase() === 'not started'))) ? element.status = 'not started' : (element.updatedStages.find(item => (item.stage === 'POST-COB'))) ? element.status = 'completed' : element.status = 'started');
          }
        });
      }
    this.cobTable = this.cobResults;
    this.cobTable = this.cobTable?.sort((a, b) => new Date(b.cobDate).getTime() - new Date(a.cobDate).getTime());
    this.pageIndex = 0;
    this.cobPaginationSize = 10;
    this.dataSourceCob = new MatTableDataSource(this.cobTable?.slice(0, 0 + this.cobPaginationSize));
  }

  downloadCobReport(data): void {
    const pack = 'cob-results'
    if(data.reportFile.split('/').length > 1) {
      data.reportFile = data.reportFile.split('/')[2];
    } else {
      data.reportFile = data.reportFile;
    }
    this.crvtService.downloadCRVT(this.data.blueprintId, this.instanceId, data.cobRunId, data.reportFile, this.clientName,pack)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  convertMiliseconds(miliseconds: number) {
    let days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

    total_seconds = Math.floor(miliseconds / 1000);
    total_minutes = Math.floor(total_seconds / 60);
    total_hours = Math.floor(total_minutes / 60);
    days = Math.floor(total_hours / 24);

    seconds = total_seconds % 60;
    minutes = total_minutes % 60;
    hours = total_hours % 24;

    hours = (hours < 10) ? '0' + hours : hours;
    minutes = (minutes < 10) ? '0' + minutes : minutes;
    seconds = (seconds < 10) ? '0' + seconds : seconds;

    return days > 0 ? (days + "days " + hours + ":" + minutes + ":" + seconds) : (hours + ":" + minutes + ":" + seconds);
  };

  onCobArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.dataSourceCob.filteredData.find(item => item.cobRunId === data.cobRunId).arrowClick = !this.dataSourceCob?.filteredData.find(item => item.cobRunId === data.cobRunId).arrowClick;
    this.dataSourceCob?.filteredData.forEach(item =>  {
      if(item.cobRunId !== data.cobRunId) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInnerCob = this.dataSourceCob?.filteredData.find(item => item.cobRunId === data.cobRunId).updatedStages;
  }

  configureCob(): any {
    this.isCobLoaded = false;
      if(this.installationSpecificationForms) {
      this.configureCobApi();
      }
    }

   configureCobApi(cobStatus?: any): void {
      const reconfigureParams = this.installationSpecificationForms;
      this.isCobLoaded = true;
      const cobData = {
        instanceName : this.data?.name,
        cobStatus : cobStatus,
        dynamicFormModel: this.installationSpecificationForms[0]
      };
    this.sidenavService.openInRightSidenav(DynamicFormComponent, cobData)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(dynamicFormModel => {
          if(dynamicFormModel) {
            const installationDocument = {};
            let operation;
            if(cobStatus === 'reconfigure') {
              operation = 'RECONFIGURE';
            } else if(cobStatus === 'update') {
              operation = 'UPDATE';
            } else {
              operation = 'CREATE';
            }
            this.installationSpecificationForms = reconfigureParams;
            this.installationSpecificationForms?.forEach(installationSpecificationForm => {
              const installationSpecificationFormValue = this.installationSpecificationService.getFormValue(
                installationSpecificationForm);
                if(cobStatus) {
                  installationSpecificationFormValue.cobParameters.PipelineID = this.data?.cob?.adoPipelineUrl ? this.data?.cob?.adoPipelineUrl.split('=').pop() : ''
                } else {
                  installationSpecificationFormValue.cobParameters.PipelineID = ''
                }
              Object.assign(installationDocument, installationSpecificationFormValue);
            });
            const data = {
              id: this.instanceId,
              inputs: installationDocument,
              operation: operation
            }
            this.cobService.putCobConfig(data)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result: any) => {
              if(result) {
                this.cobResultsTable();
                this.instanceService.triggerRefresh();
              }
            },(error)=>{
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
                data: {
                  title: translate('ERROR_DIALOG.UPDATE_COB_FAILED'),
                  description: errorMessage}
              });
            });
          }
        });
      }

onClickLink(cobId): void {
  let url;
  url = `${this.adoPipelineUrl}/${this.adoProjectName}/_build/results?buildId=${cobId}`;
  window.open(url, '_blank');
}

  onEditClick(data, cobStatus): void {
    this.menuItemClick();
    this.getPreviousVersionData(data);
    if(this.installationSpecificationForms) {
      this.configureCobApi(cobStatus);
    }
  }
}
